// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Step_step__XwCYR {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/views/ProductDetailView/Step/Step.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AACF","sourcesContent":[".step {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"step": `Step_step__XwCYR`
};
export default ___CSS_LOADER_EXPORT___;
